import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-teshushenqing",
  "use": "icon-teshushenqing-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-teshushenqing\"><g fill-rule=\"nonzero\"><path d=\"M14.44 4.038c-.86 0-1.624-.558-1.896-1.385l-.088-.268A2.003 2.003 0 0010.558.999H5.441c-.86 0-1.625.558-1.897 1.385l-.088.269a2.003 2.003 0 01-1.898 1.385.562.562 0 00-.559.566v7.537h.007l6.206 2.695a1.98 1.98 0 001.576 0l6.206-2.695h.003V4.604a.56.56 0 00-.557-.566zm-.442 7.444L8.39 13.92a.976.976 0 01-.78 0l-5.61-2.438V5.005a3.003 3.003 0 002.407-2.039l.087-.27c.138-.417.519-.698.948-.698h5.117c.43 0 .811.281.949.699l.088.268a3.02 3.02 0 001.91 1.922c.16.053.326.092.493.118v6.477z\" /><path d=\"M8 4a4 4 0 100 8 4 4 0 000-8zm2.766 5.168a3.014 3.014 0 11-5.558-2.335 3.014 3.014 0 015.558 2.335z\" /><path d=\"M9.313 6.647L7.667 8.294l-.98-.98a.5.5 0 00-.707.706l1.333 1.333a.5.5 0 00.707 0l2-2a.5.5 0 00-.707-.706z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/teshushenqing.svg
// module id = 510
// module chunks = 4